import { registerNewBatch, deliverFiles } from "../../../../upload/services/batchActions";
import { stageFilesLocally, finalizeLocalBatch } from "../../../../upload/services/storageService";
/**
 * 🚀 SAVE ESG TAXONOMY CONTROLLER
 * Isolated logic for promoting validated "Single Pot" JSON to the Clean S3 Route.
 * Replicates Sandbox logic but enforces Authority Labels for AWS Discovery.
 */
export const SaveESG_taxonomyController = {
    promoteToCleanRoute: async (fullPot, siteKey) => {
        console.group("🚀 [TAXONOMY_PROMOTION] Initiating Clean Route Delivery");
        
        try {
            // 1. SYSTEM AUTHORITY: User Prompts for Discovery Labels
            const taxonomyName = window.prompt("Enter a unique name for this Taxonomy version:", "ESRS_Standard_v1");
            if (!taxonomyName) {
                console.warn("Promotion cancelled by user.");
                return { success: false, reason: "CANCELLED" };
            }

            const validFrom = window.prompt("Enter the 'Valid From' date (YYYY-MM-DD):", new Date().toISOString().split('T')[0]);
            
            // 2. ISOLATION: Create the Virtual File from memory (The Single Pot)
            const blob = new Blob([JSON.stringify(fullPot, null, 2)], { type: "application/json" });
            const fileName = `${taxonomyName.replace(/\s+/g, '_')}_${new Date().getTime()}.json`;
            const virtualFile = new File([blob], fileName, { type: "application/json" });

            // 3. ROUTING & LABELS: Mapping for AWS S3 Metadata Parity
            // These keys are automatically converted to x-amz-meta-* by batchDelivery.js
            const metadata = {
                batchType: 2, // Authority Type
                targetBucket: process.env.REACT_APP_SITE_CLEAN_BUCKET, 
                targetRoot: "taxonomy/registry/integrated/",
                S3CorsValue: "esg", // Mandatory for JIT signature parity
                
                // Authority Labels for AWS Discovery/Trawler
                taxonomyName: taxonomyName,
                validFrom: validFrom,
                status: "Draft",
                versionLabel: "Validated_Sync"
            };

            console.log(`📡 [STEP 1] Registering Batch Authority: ${fileName}`);
            const newBatch = await registerNewBatch([virtualFile], { siteKey }, metadata);

            console.log(`💾 [STEP 2] Staging Virtual Bits to Dexie (Batch: ${newBatch.batchId})`);
            await stageFilesLocally([virtualFile], newBatch.batchId, siteKey);
            await finalizeLocalBatch(newBatch.batchId, siteKey, newBatch.hash, newBatch.timestamp, metadata);

            console.log(`🛰️ [STEP 3] Handing off to QueueManager for S3 Delivery`);
            // This triggers the animated progress bars in your BatchMonitorView
            await deliverFiles(newBatch.batchId, [virtualFile], siteKey);

            console.groupEnd();
            return { success: true, batchId: newBatch.batchId, fileName };

        } catch (err) {
            console.error("💀 [PROMOTION_FAILED]", err);
            console.groupEnd();
            throw err;
        }
    }
};